var makeELementStickyInBoundry = function (wrapper, ele, offsetElement, widthElement) {
    var floatingElement = ele;
    var state = {
        top: 0,
        left: 0,
        fixed: false,
        width: 0,
        // TODO - if screen is too small disable this.
        enabled: true,
    };
    var makeFixed = function () {
        if (floatingElement) {
            var width = wrapper.offsetWidth > 1000
                ? widthElement.offsetWidth
                : wrapper.offsetWidth;
            if (wrapper.offsetWidth > 1000) {
                floatingElement.setAttribute('style', "width: ".concat(width, "px; position: fixed; top: 0; left: ").concat(state.left, "px"));
            }
            else {
                floatingElement.setAttribute('style', "width: ".concat(width, "px; position: fixed; bottom: 8px; left: ").concat(state.left, "px"));
            }
        }
    };
    var makeFixedBottom = function () {
        if (floatingElement) {
            var width = wrapper.offsetWidth > 1000
                ? widthElement.offsetWidth
                : wrapper.offsetWidth;
            floatingElement.setAttribute('style', "width: ".concat(width, "px; position: absolute; bottom: 0;"));
        }
    };
    var makeUnfixed = function () {
        if (floatingElement) {
            floatingElement.setAttribute('style', "");
        }
    };
    // Toggle states
    var updatePosition = function () {
        if (!state.enabled) {
            return;
        }
        var _a = wrapper.getBoundingClientRect(), top = _a.top, left = _a.left, bottom = _a.bottom;
        var _b = ele.getBoundingClientRect(), eleBottom = _b.bottom, eleTop = _b.top;
        // Update state
        state.top = top;
        state.left =
            left +
                (wrapper.offsetWidth > 1000 ? (offsetElement === null || offsetElement === void 0 ? void 0 : offsetElement.offsetWidth) || 0 : 0);
        state.width = wrapper.offsetWidth;
        // Update position
        if (state.fixed && top <= 0) {
            makeFixed();
        }
        if (wrapper.offsetWidth > 1000) {
            // Assign states
            if (bottom <= eleBottom && eleTop <= 0) {
                state.fixed = true;
                makeFixedBottom();
            }
            else if (top <= 0 && !state.fixed) {
                state.fixed = true;
                makeFixed();
            }
            else if (top >= 0 && state.fixed) {
                state.fixed = false;
                makeUnfixed();
            }
        }
        else {
            if (state.fixed && bottom < window.innerHeight) {
                makeFixedBottom();
            }
            else if (top <= 0 && !state.fixed) {
                state.fixed = true;
                makeFixed();
            }
            else if (top >= 0 && state.fixed) {
                state.fixed = false;
                makeUnfixed();
            }
        }
    };
    // Event scroll
    document.addEventListener('scroll', function (event) {
        updatePosition();
    });
    // Handle resize
    window.addEventListener('resize', function () {
        updatePosition();
    });
};
export default makeELementStickyInBoundry;
